import { PATIENT_DETAILS_PATH } from "@/pages/patients/const";
import { REPORT_VIEW_PAGE } from "./view/const";

export const ALL_REPORTS_PAGE = "reports";
export const ALL_REPORTS_PATH = `${PATIENT_DETAILS_PATH}/${ALL_REPORTS_PAGE}`;
export const REPORT_PAGE = ":reportId";
export const REPORT_PATH = `${ALL_REPORTS_PATH}/${REPORT_PAGE}`;
export const REPORT_VIEW_PATH = `${REPORT_PATH}/${REPORT_VIEW_PAGE}`;
